import React from 'react';
import { useLanguage, useMessages } from '../i18n/I18n';
import { LANGUAGES, LANGUAGE_NAMES } from '../i18n/language';

/** FR / EN, for the screens without an account (sign-in, admin tools): the choice stays in this browser */
const LanguageSwitch: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  const t = useMessages('settings');

  return (
    <div className="language-switch" role="group" aria-label={t.language}>
      {LANGUAGES.map(option => (
        <button
          key={option}
          type="button"
          lang={option}
          title={LANGUAGE_NAMES[option]}
          aria-label={LANGUAGE_NAMES[option]}
          aria-pressed={option === language}
          onClick={() => setLanguage(option)}
        >
          {option.toUpperCase()}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitch;
